import { render } from "./PelangganUpdateModal.vue?vue&type=template&id=cce793a8&scoped=true"
import script from "./PelangganUpdateModal.vue?vue&type=script&lang=js"
export * from "./PelangganUpdateModal.vue?vue&type=script&lang=js"

import "./PelangganUpdateModal.vue?vue&type=style&index=0&id=cce793a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cce793a8"

export default script